import { observer } from 'mobx-react-lite'
import { type WorkspacePostingOpportunityViewModel } from '@/features/opportunities/workspace-postings-opportunities/WorkspacePostingOpportunityViewModel'
import { WorkspaceOpportunityListItem } from '@/features/opportunities/workspace-postings-opportunities/components/WorkspaceOpportunitiesList/WorkspaceOpportunityListItem'

export interface WorkspaceOpportunityListItemContainerProps {
  opportunityVm: WorkspacePostingOpportunityViewModel
}

export const WorkspaceOpportunityListItemContainer = observer(
  function WorkspaceOpportunityListItemContainer({
    opportunityVm,
  }: WorkspaceOpportunityListItemContainerProps) {
    const opportunity = opportunityVm.opportunity
    return (
      <WorkspaceOpportunityListItem
        opportunityId={opportunityVm.opportunityId}
        isDisabled={opportunityVm.disabled}
        selected={opportunityVm.isSelected}
        onSelect={opportunityVm.select}
        jobTypes={opportunityVm.jobTypes}
        requirements={opportunityVm.requirements}
        isApplicant={opportunity.isApplicant}
        isActive={opportunity.isActive}
        isInReview={opportunity.isInReview}
      />
    )
  },
)
